import { hyRequestStar } from '../index.js'

// 鉴权
export function getToken(params) {
  return hyRequestStar.get({
    url: '/api/user/public-resource/admin/api/authentication',
    params: {
      secret: params.secret,
      appid: params.appid
    }
  })
}

// getDict
export function getDict(params) {
  return hyRequestStar.get({
    url: '/api/manage/manage-api-ta/travel-agency-plug/dict',
    params: {
      type: params.type
    }
  })
}

// 首页
export function getStarPlay() {
  return hyRequestStar.get({
    url: '/api/manage/manage-api-ta/travel-agency-star-play/index'
  })
}

// 首页-套餐列表
export function getStarPlayList(params) {
  return hyRequestStar.get({
    url: '/api/manage/manage-api-ta/travel-agency-star-play/index-list',
    params: {
      id: params?.id,
      day: params?.day,
      type: params?.type
    }
  })
}

// 升级-套餐详情获取
export function getStarPlayPackageDetails(params) {
  return hyRequestStar.get({
    url: '/api/manage/manage-api-ta/travel-agency-star-play/package-details',
    params: {
      id: params?.id
    }
  })
}

// 购买-套餐详情获取
export function getStarPlayPackageId(params) {
  return hyRequestStar.get({
    url: `/api/manage/manage-api-ta/travel-agency-star-play/package/${params.id}`
  })
}

// 购买-套餐规格获取
export function getStarPlaySpecsList(params) {
  return hyRequestStar.post({
    url: `/api/manage/manage-api-ta/travel-agency-star-play/specs-list`,
    data: {
      packageId: params?.packageId,
      age: params?.age,
      day: params?.day
    }
  })
}

// 随星游-下单
export function createOrder(params) {
  return hyRequestStar.post({
    url: `/api/manage/manage-api-ta/travel-agency-star-play/create-order`,
    data: {
      isPayInsure: params?.isPayInsure,
      id: params?.id,
      userName: params?.userName,
      specsId: params?.specsId,
      idCard: params?.idCard,
      detailsReqs: params?.detailsReqs,
      day: params?.day
    }
  })
}

// 随星游-升级
export function upgradeOrder(params) {
  return hyRequestStar.post({
    url: `/api/manage/manage-api-ta/travel-agency-star-play/upgrade-ticket`,
    data: {
      reqList: params.reqList
    }
  })
}

// 随星游-公告
export function getNotice() {
  return hyRequestStar.get({
    url: `/api/manage/manage-api-ta/travel-agency-resource/notice`
  })
}
